import type { OrganizationFormInput } from '../types/schemas'
import type {
  OrganizationDefaultFormFileKey,
  OrganizationLogoKey,
  OrgEditTab,
} from '../types'

export const BASE_ORG_TABS: Array<{ id: OrgEditTab; label: string }> = [
  { id: 'orgprofile', label: 'Org Profile' },
  { id: 'skipreimbursement', label: 'Skip Reimbursement Form' },
  { id: 'defaultform', label: 'Default Form' },
  { id: 'stockletter', label: 'Stock Letter' },
  { id: 'helpabout', label: 'Help / About Page' },
]

export function getOrgTabs(orgId?: number): Array<{ id: OrgEditTab; label: string }> {
  if (orgId === 1) {
    return [
      { id: 'orgprofile', label: 'Org Profile' },
      { id: 'certificate', label: 'Certificate / Contract' },
      { id: 'skipreimbursement', label: 'Skip Reimbursement Form' },
      { id: 'defaultform', label: 'Default Form' },
      { id: 'stockletter', label: 'Stock Letter' },
      { id: 'helpabout', label: 'Help / About Page' },
    ]
  }
  return BASE_ORG_TABS
}

export const ORG_TABS = BASE_ORG_TABS

export const CERTIFICATE_CONTRACT_VARIABLES: readonly string[] = [
  '$certificate_paid_date',
  '$certificate_id',
  '$property_name',
  '$company_name',
  '$property_landlord_name',
  '$all_applicants_name',
  '$lease_start_date',
  '$lease_end_date',
  '$rent_amount',
  '$property_address',
  '$property_unit',
]

export const SKIP_REIMBURSEMENT_FORM_VARIABLES: readonly string[] = [
  '$property_name',
  '$company_name',
  '$property_address',
  '$prop_address2',
  '$property_city',
  '$property_state',
  '$property_zipcode',
  '$property_manager',
  '$contact_no',
  '$contract_start',
  '$contract_end',
  '$rent_amount',
  '$lease_number',
  '$resident_name1',
  '$resident_name2',
  '$resident_name3',
  '$resident_name4',
  '$notification_date',
  '$lease_agreement',
  '$payment_ledger',
  '$accept_partial_payment',
  '$partial_payment',
  '$signature',
  '$date',
  '$ip_address',
  '$name_insure',
  '$sign_date',
  '$claim_amount',
  '$first_month_np',
]

export const DEFAULT_STATEMENT_FORM_VARIABLES: readonly string[] = [
  '$company_name',
  '$property_name',
  '$resident_name',
  '$rental_status',
  '$unit_number',
  '$roommate',
  '$certificate_number',
  '$certificate_amount',
  '$lease_start_date',
  '$lease_end_date',
  '$verified_lease_start_date',
  '$verified_lease_end_date',
  '$rent_amount',
  '$daily_rent_amount',
  '$first_month_rent_not_paid',
  '$notification_date',
  '$new_resident_movein_date',
  '$gross_period_default',
  '$gross_default_amount',
  '$adjusted_notice',
  '$max_claim_end',
  '$max_reason',
  '$adjusted_default_period',
  '$unused_security_deposit',
  '$loss_adjustment',
  '$partial_payment_amount',
  '$net_default_payment',
  '$lost_revenue_amount',
  '$lost_time',
  '$lost_revenue_content',
  '$payment_information_row',
  '$generate_date',
  '$adjustment_reason_info',
  '$adjusted_default_amount',
]

export const DEFAULT_PAYMENT_INFO_VARIABLES: readonly string[] = [
  '$payment_amount',
  '$payment_date',
  '$payment_log',
  '$payment_type',
  '$payment_checknums',
  '$payment_status',
  '$total_payments_amount',
]

export const STOCK_LETTER_VARIABLES: readonly string[] = ['$company_name', '$issue_date', '$stock_class']

export const ORG_FORM_SUBHEADING =
  'mb-2.5 block text-sm font-extrabold tracking-wide text-slate-900'

export const ORGANIZATION_FORM_DEFAULT_VALUES: OrganizationFormInput = {
  org_name: '',
  org_abbrev: '',
  charity: '' as any,
  org_website: '',
  org_phone: '',
  org_email: '',
  org_address: '',
  org_city: '',
  org_state: '',
  org_zipcode: '',
  org_color: '#ffffff',
  email_footer: '',
  system_announcement: '',
  about_content: '',
  about_content_applicant: '',
  about_content_pmc: '',
  stock_letter: '',
  lost_revenue_content: '',
  payment_information_row: '',
  skip_claim_form: '',
  default_payment_statement_form: '',
  certificate_template: '',
}

export const LOGO_IMAGE_ACCEPT = 'image/jpeg,image/jpg,image/png,.jpg,.jpeg,.png'
export const ALLOWED_LOGO_MIME = new Set(['image/jpeg', 'image/jpg', 'image/png'])
export const DEFAULT_FORM_PDF_ACCEPT = 'application/pdf,.pdf'

export const EMPTY_LOGO_SERVER: Record<OrganizationLogoKey, string> = {
  org_logo: '',
  org_swoosh_logo: '',
  org_image: '',
}

export const EMPTY_DEFAULT_FORM_SERVER: Record<OrganizationDefaultFormFileKey, string> = {
  ach_form_file: '',
  statement_instruction_file: '',
}
